<template>
  <div class="page-join-container">
    <div class="join__inner">
      <div class="join__page-title scrollObj">
        <p>join us</p>
      </div>
      <div class="join__group">
        <div class="group__item" v-for="(group, index) in joins" :key="index">
          <div class="item__title scrollObj">
            <div
              class="title__inner"
              :style="{
                borderColor: lineColor
              }"
            >
              <p>{{ group.title.en }}</p>
              <p>{{ group.title.cn }}</p>
            </div>
          </div>
          <div class="item__lists">
            <div class="list__inner">
              <div
                class="list__job-item scrollObj"
                v-for="(job, jindex) in group.lists"
                :key="jindex"
                :class="[$bowser.mobile ? 'activeShow' : 'hoverShow']"
                @click="$bowser.mobile && contentShowMore(job.id)"
                :data-id="job.id"
                ref="jobItems"
              >
                <div
                  class="job-item__inner"
                  :class="[currentShowDetail === job.id ? 'currentActived animated' : 'animated']"
                >
                  <div
                    class="line"
                    :style="{
                      backgroundColor: $bowser.mobile ? '#000' : lineColor
                    }"
                  ></div>
                  <div class="job-item__title">
                    <p>{{ job.name.en }} {{ job.name.cn }}</p>
                  </div>
                  <div
                    class="job-item__content"
                    ref="contentWrapper"
                    :class="{
                      '-detail-show': currentShowDetail === job.id
                    }"
                  >
                    <div
                      v-if="$bowser.mobile"
                      class="content__mobile-inner"
                      v-html="job.content"
                    ></div>
                    <div v-else v-html="job.content"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="join__bottom-container">
        <div class="bottom__main-body">
          <p class="body__title scrollObj">to apply 应聘渠道</p>
          <p class="body__content scrollObj">
            有意者请将简历及个人作品发至邮箱：<a href="mailto:hr@wjid.com.cn">HR@wjid.com.cn</a>
          </p>
        </div>
      </div>
      <page-footer v-if="!$bowser.mobile" class="join-footer"></page-footer>
    </div>
    <page-footer v-if="$bowser.mobile" class="join-footer"></page-footer>
  </div>
</template>

<script>
import { jobs } from '@/utils/data';
import pageFooter from '../common/footer.vue';

const colors = ['#00a69b', '#c3d714', '#f8b61c', '#ae027e'];

export default {
  name: 'join',
  components: {
    pageFooter,
  },
  data() {
    return {
      joins: [],
      currentShowDetail: 0,
    };
  },
  computed: {
    lineColor() {
      const temp = colors;
      const data = [];
      for (let i = 0; i < 2; i += 1) {
        const c = Math.floor(Math.random() * (temp.length - i));
        data.push(temp[c]);
        temp[c] = temp[temp.length - i - 1];
      }
      return data;
    },
  },
  mounted() {
    const that = this;
    that.$nextTick(() => {
      if (that.$bowser.mobile) {
        // 移动端初始化内容单个内容高度
        that.$refs.contentWrapper.forEach((item) => {
          const child = item.childNodes['0'];
          item.dataset.contentHeight = Math.ceil(child.getBoundingClientRect().height);
        });
        that.contentShowMore(that.$refs.jobItems['0'].dataset.id);
      }
    });
  },
  beforeRouteEnter(to, from, next) {
    jobs().then((res) => {
      next((vm) => {
        vm.setData(res);
      });
    });
  },
  methods: {
    contentShowMore(id) {
      id = Number(id);
      if (this.currentShowDetail === id) {
        // 关闭当前的
        this.currentShowDetail = 0;
      } else if (this.currentShowDetail !== id && this.currentShowDetail !== 0) {
        // 先关闭之前的
        const lastJob = this.$refs.jobItems.find(
          (item) => Number(item.dataset.id) === this.currentShowDetail,
        );
        lastJob.querySelector('.job-item__content').style.height = 0;
        this.currentShowDetail = id;
      } else {
        this.currentShowDetail = id;
      }

      const job = this.$refs.jobItems.find((item) => Number(item.dataset.id) === id);
      const content = job.querySelector('.job-item__content');
      if (this.currentShowDetail > 0) {
        // job 展开
        content.style.height = `${content.dataset.contentHeight}px`;
      } else {
        // job 闭合
        content.style.height = 0;
      }
    },
    setData(data) {
      this.joins = data.lists;
    },
  },
};
</script>

<style></style>
